import React from 'react'
import PropTypes from 'prop-types'
import {graphql, StaticQuery} from 'gatsby'
import styled from '@emotion/styled'

import {QueryedButton} from '../Button'
import WavyBackground from '../WavyBackground'
import StarsContainer from '../Stars'
import WidthContainer from '../WidthContainer'

const RootContainer = styled(WavyBackground)`
`
RootContainer.defaultProps = {
	type: 'darkBlue',
}


const Stars = styled(StarsContainer)`
	position: absolute;
	top: 0;
	margin: 0 auto;
`
Stars.defaultProps = {
	width: '60rem',
	rotate: '45deg',
}

const InnerContainer = styled(WidthContainer)`
	color: white;
	text-align: center;
	position: relative;
	margin-top: 0;
	margin-bottom: 2rem;
`

const Title = styled.h1`
	@media only screen and (max-width: 700px) {
		font-size: ${props => props.theme.fontSizes.big30};
	}
	
`

const Meta = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.medium};
`

const Text = styled.div`
	max-width: 32rem;
	margin: 3rem auto;

`

const Buttons = styled.div`
	margin: -0.5rem -1rem;	
	
	a {
		margin: 0.5rem 1rem;
	}
`
const ConferenceExpositionSection = ({className, noTopWave, linkOutsite}) => <StaticQuery query={graphql`
{
	conference: file(relativePath: {eq: "pages/conferencePage.json"}) {
      childPagesJson {
        childPagesJsonWithRelativePaths {
	  		externalUrl
			intro {
				title
				meta
				text
				leftButton {
					label
					link
				}
				rightButton {
					label
					link
				}
			}
        }
      }
    }
}
`} render={(rawData) => {
	const data = rawData.conference.childPagesJson.childPagesJsonWithRelativePaths

	return <RootContainer type={noTopWave ? 'darkBlueBottom' : 'darkBlue'} className={className}>
		<Stars/>
		<InnerContainer>
			<Title>{data.intro.title}</Title>
			<Meta>{data.intro.meta}</Meta>
			<Text>{data.intro.text}</Text>
			<Buttons>
				{linkOutsite
					? <QueryedButton data={{...data.intro.leftButton, link: data.externalUrl}}/>
					: <QueryedButton data={data.intro.leftButton}/>}
				<QueryedButton inverted data={data.intro.rightButton}/>
			</Buttons>
		</InnerContainer>
	</RootContainer>
}}/>

ConferenceExpositionSection.propTypes = {
	className: PropTypes.string,
	noTopWave: PropTypes.bool,
}

ConferenceExpositionSection.defaultProps = {
	className: '',
	noTopWave: false,
}

export default ConferenceExpositionSection
